<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-模拟显示-砍价
    -->
  <div class="drag optional" :class="{ selected: index === selectedIndex }" @click.stop="$parent.$parent.onEditer(index)">
    <div class="diy-sharpproduct">
      <div class="sharpproduct-head d-b-c">
        <div class="left d-s-c">
          <div class="name">
            {{$t('活动砍价')}}
          </div>
          <div class="datetime d-s-c">
            <span class="text"></span>
            <span class="box hour">12</span>
            <span class="text">{{$t('天')}}</span>
            <span class="box hour">30</span>
            <span class="text">:</span>
            <span class="box hour">00</span>
            <span class="text">:</span>
            <span class="box hour">00</span>
          </div>
        </div>
        <div class="right" style="color: #4B30FF;">{{$t('更多')}}</div>
      </div>
      <ul class="product-list" :class="['column__' + item.style.column]" :style="getUlwidth(item)">
        <li class="product-item" v-for="(product, index) in item.data" :key="index">
          <div class="product-sale" v-if="item.style.show.peoples == '1'">{{$t('已抢2件')}}</div>
          <div class="product-cover"><img v-img-url="product.image" /></div>
          <div class="product-info">
            <div v-if="item.style.show.productName == '1'" class="product-title">{{ product.product_name }}</div>
            <div class="price d-b-c f12">
              <div>
                <div v-if="item.style.show.originalPrice == '1'" class="">
                  <span style="color:#f6220c;" class="f12">¥</span><span style="color:#f6220c;" class="f16 fb">233.00</span>
                </div>
              </div>
            </div>
            <div class="btns d-c-c">
              <el-button class="bargain_btns">{{$t('立即砍价')}}</el-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-edit-del">
      <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">{{$t('删除')}}</div>
    </div>
  </div>
</template>

<script>
  import ProductApi from '@/api/product.js';
  export default {
    data() {
      return {
        /*菜品列表*/
        tableData: [],
        /*分类id*/
        category_id: 0
      };
    },
    created() {},
    props: ['item', 'index', 'selectedIndex'],
    methods: {

      /*计算宽度*/
      getUlwidth(item) {
        if (item.style.display == 'slide') {
          let total = 0;
          if (item.params.source == 'choice') {
            total = item.data.length;
          } else {
            total = item.defaultData.length;
          }
          let w = 0;
          if (item.style.column == 2) {
            w = total * 150;
          } else {
            w = total * 100;
          }
          return 'width:' + w + 'px;';
        }
      }
    }
  };
</script>

<style>
  .diy-sharpproduct {
    background-color: #EBE8FF;
    padding: 0 10px;
  }

  .diy-sharpproduct .product-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .diy-sharpproduct .product-list .product-title {
    margin-top: 4px;
    height: 40px;
    line-height: 20px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .diy-sharpproduct .display__list .column__3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .diy-sharpproduct .product-list.column__3 .product-item {
    width: 150px;
    margin-right: 10px;
    background: #ffffff;
    border-radius: 6px;
  }
   .diy-sharpproduct .product-list.column__3 .product-item .product-info{
    padding: 0 5px;
  }
  .diy-sharpproduct .product-list.column__3 .product-item .product-sale{
    padding: 10px;
    font-size: 12px;
    color: #999999;
  }
  .diy-sharpproduct .product-list.column__3 .product-item .product-cover {
    width: 85px;
    height: 85px;
    margin: 0 auto;
    overflow: hidden;
  }

  .diy-sharpproduct .product-list.column__3 .product-item .product-cover img {
    width: 85px;
  }

  .diy-sharpproduct .product-list.column__3 .product-title {
        margin-top: 16px;
        height: 20px;
        line-height: 20px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 15px;
  }

  .sharpproduct-head {
    height: 40px;
  }

  .sharpproduct-head .name {
    font-size: 18px;
    font-weight: bold;
    color: #4B30FF;
  }

  .sharpproduct-head .datetime {
    margin-left: 20px;
  }

  .sharpproduct-head .datetime>span {
    display: inline-block;
  }

  .sharpproduct-head .datetime .text {
    padding: 0 2px;
    color: #4B30FF;
  }

  .sharpproduct-head .datetime .box {
    padding: 2px;
    background: #FFFFFF;
    color: #4B30FF;
    border-radius: 4px;
  }
  .bargain_btns{
    background: linear-gradient(90deg, #7776FF 0%, #762CF1 100%);
    border: none;
    color: #FFFFFF;
    width: 80px;
    height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin-bottom: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/buildStore/website/homePageEdit/model/BargainProduct.vue